import classNames from "classnames"
import { Heading } from "@oysterhr/ui"

type QuoteCardProps = {
  title?: string
  titleAdornment?: string | React.ReactElement
  items?: React.ReactElement[]
} & React.HTMLAttributes<HTMLElement>

export function QuoteCard({ title, titleAdornment, items, className, ...rest }: QuoteCardProps) {
  const cn = classNames("p-4 min-h-[14rem] h-max", className)
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <section className={cn} {...rest}>
      <header className={"mb-2 border-0 pb-2"}>
        <div className="flex items-center justify-between">
          <Heading size="lg">{title}</Heading>
          {titleAdornment}
        </div>
      </header>
      <ul>{items}</ul>
    </section>
  )
}
